import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { DATOS_API } from 'app/auth/auth.datos';

@Injectable({
  providedIn: 'root'
})



export class ForAllService {


  // private ip = 'http://35.232.140.117:3800';

  constructor(
    private httpClient: HttpClient
  ) { }

  public getInstituteArray() {
    return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.forAll.getInstituto);
      // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
    // return this.httpClient.get(this.ip+'/api_empresa/Institutos', { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getParams(data) {
    console.log("");

    return this.httpClient.post(DATOS_API.url +DATOS_API.endpoints.forAll.postStatements+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/Forall/statements/'+this.getCompanyID(),data,
                                // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getPracticesSaved(data) {


    /*
    this.httpClient.post(this.ip+'/api_empresa/ForallGET/'+this.getCompanyID(), data)
    .subscribe((data) => {
    console.log(data);

    }, error => {
      console.log("ocurrio un error: ");
      console.log(error);

    });*/



    return this.httpClient.post(DATOS_API.url+DATOS_API.endpoints.forAll.postForallGet+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/ForallGET/'+this.getCompanyID(),data,
                                // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public registerForall(data){

    return this.httpClient.post(DATOS_API.url +DATOS_API.endpoints.forAll.postGuardar+this.getCompanyID(), data);
    // return this.httpClient.post(this.ip+'/api_empresa/Forall/Guardar/'+
      // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});

  }

  public getTest(data){

  return this.httpClient.post(DATOS_API.url +DATOS_API.endpoints.forAll.postStatements+
    this.getCompanyID(), data);
  // return this.httpClient.post(this.ip+'/api_empresa/Forall/statements/'+
      // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});

    /*
    return this.httpClient.get(this.ip+'/api_empresa/Forall/statements/'+this.getCompanyID(),
                                { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
*/
    //return this.httpClient.get(this.ip+'/api_empresa/Forall/statements/'+this.getCompanyID(),data, { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  private getToken():string{
    const token = localStorage.getItem('token');

    return token;
  }


  private getCompanyID():string{
    const token = localStorage.getItem('companyID');

    return token;
  }



  public updateOrderForall(data){

    return this.httpClient.post(DATOS_API.url +DATOS_API.endpoints.forAll.postCambiarOrden+this.getCompanyID(), data);
    // return this.httpClient.post(this.ip+'/api_empresa/Forall/cambiarOrden/'+
      // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }


}
